<template>
  <div>
    <v-container fluid class="lighten-12 container">
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pr-1">
          <div id="app">
            <v-app id="inspire">
              <v-row class="fill-height">
                <v-col>
                  <v-sheet height="64">
                    <v-toolbar flat color="white">
                      <v-btn outlined class="mr-4" @click="setToday">
                        Today
                      </v-btn>
                      <v-btn fab text small @click="prev">
                        <v-icon small>mdi-chevron-left</v-icon>
                      </v-btn>
                      <v-btn fab text small @click="next">
                        <v-icon small>mdi-chevron-right</v-icon>
                      </v-btn>
                      <v-toolbar-title>{{ titleMonth }}</v-toolbar-title>
                      <div class="flex-grow-1"></div>
                      <v-menu bottom right>
                        <template v-slot:activator="{ on }">
                          <v-btn outlined v-on="on">
                            <span>{{ typeToLabel[type] }}</span>
                            <v-icon right>mdi-menu-down</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="type = 'day'">
                            <v-list-item-title>Day</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="type = 'week'">
                            <v-list-item-title>Week</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="type = 'month'">
                            <v-list-item-title>Month</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="type = '4day'">
                            <v-list-item-title>4 days</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-toolbar>
                  </v-sheet>
                  <v-sheet height="600">
                    <v-calendar
                      ref="calendar"
                      v-model="focus"
                      color="primary"
                      :events="eventsdata"
                      :event-color="getEventColor"
                      :event-margin-bottom="3"
                      :now="today"
                      :type="type"
                      :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                      @click:event="showEvent"
                      @click:more="viewDay"
                      @click:date="viewDay"
                      @change="updateRange"
                    ></v-calendar>
                    <v-menu
                      v-model="selectedOpen"
                      :close-on-content-click="false"
                      :activator="selectedElement"
                      offset-x
                    >
                      <v-card color="grey lighten-4" min-width="350px" flat>
                        <v-toolbar :color="selectedEvent.color" dark>
                          <v-btn icon @click="EditEvent(selectedEvent.id)">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-toolbar-title
                            v-html="selectedEvent.name"
                          ></v-toolbar-title>
                          <div class="flex-grow-1"></div>
                          <v-btn icon>
                            <v-icon>{{
                              selectedEvent.icon
                                ? selectedEvent.icon
                                : 'mdi-heart'
                            }}</v-icon>
                          </v-btn>
                          <v-btn icon>
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </v-toolbar>
                        <v-card-text>
                          <span v-html="selectedEvent.details"></span>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn
                            text
                            color="secondary"
                            @click="selectedOpen = false"
                          >
                            Cancel
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-app>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import axios from '@/plugins/axios';
import { Event } from '../../models/Event';
import * as moment from 'moment/moment';
export default {
  data: () => ({
    focus: '',
    titleMonth: '',
    EditEventVisible: false,
    type: 'month',
    event: new Event(),
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days',
    },
    selectedEvent: {},
    EventsDataMap: {},
    selectedElement: null,
    selectedOpen: false,
    eventsdata: [],
    events: [],
    colors: [
      'blue',
      'indigo',
      'deep-purple',
      'cyan',
      'green',
      'orange',
      'grey darken-1',
    ],
    names: [
      'Meeting',
      'Holiday',
      'PTO',
      'Travel',
      'Event',
      'Birthday',
      'Conference',
      'Party',
    ],
  }),
  mounted() {
    this.$refs.calendar.checkChange();
  },
  methods: {
    GetEvents() {
      axios
        .get(`events`)
        .then((res) => {
          var eventsdata = new Event();
          this.eventsdata = eventsdata.toListView(res.data.data);
        })
        .catch((err) => {
          this.messages = err.data;
        });
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = 'day';
    },
    EditEvent(eventid) {
      this.$router.push(`/event/edit/${eventid}`);
    },
    getEventColor(event) {
      return event.color;
    },

    setToday() {
      this.focus = '';
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },

    updateRange(event) {
      this.titleMonth = moment(event.start.date).format("MMMM 'YYYY");

      // this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
  },
  components: {},
  mounted() {
    this.GetEvents();
  },
  created() {
    this.GetEvents();
  },
};
</script>
